import { ComponentType } from '../../table_component'
import { Schema } from '../../types'

export const seasonalitySchema: Schema = {
  title: 'Seasonality',
  level: 1,
  columns: [
    {
      id: 'note',
      name: 'Note',
      component: ComponentType.Text
    }
  ]
}

export const qpsSchema: Schema = {
  title: 'Breakdown by QPS',
  subTitle: 'Metric by Performance Overview --> QPS',
  level: 2,
  columns: [
    {
      id: 'qps_type',
      name: 'QPS Type',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    }
  ]
}

export const clientRequestSchema: Schema = {
  title: 'Breakdown by Client Side KV Request',
  subTitle: 'Metric by Performance Overview --> KV/TSO Request OPS',
  level: 2,
  columns: [
    {
      id: 'request_type',
      name: 'KV Request Type',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    }
  ]
}

export const tikvRequestSchema: Schema = {
  title: 'Breakdown by TiKV Side KV Request',
  subTitle: 'Metric by TiKV-Details --> Cluster --> QPS',
  level: 2,
  columns: [
    {
      id: 'request_type',
      name: 'KV Request Type',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    }
  ]
}

export const cpsSchema: Schema = {
  title: 'Breakdown by CPS type',
  subTitle: 'Metric by Performance Overview --> CPS by type',
  level: 2,
  columns: [
    {
      id: 'cps_type',
      name: 'CPS Type',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    }
  ]
}

export const profileOthersSchema: Schema = {
  title: 'Others',
  level: 2,
  columns: [
    {
      id: 'no',
      name: 'No.',
      component: ComponentType.NO
    },
    {
      id: 'name',
      name: 'Statistic Name',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    },
    {
      id: 'std',
      name: 'Std',
      component: ComponentType.MetricStats
    },
    {
      id: 'location',
      name: 'Metric Location',
      component: ComponentType.Text
    }
  ]
}

export const backgroundEventSchema: Schema = {
  title: 'Background Events',
  level: 1,
  columns: [
    {
      id: 'note',
      name: 'Note',
      component: ComponentType.Text
    }
  ]
}
